import { Grid, Typography } from "@mui/material";
import AdditionalDetailTable from "components/Liquidations/LiquidationDetail/DetailTables/Aditionals/AdditionalsDetailTable";
import DischargeDetailTable from "components/Liquidations/LiquidationDetail/DetailTables/IncomeDischarges/DischargeDetailTable";
import IncomeDetailTable from "components/Liquidations/LiquidationDetail/DetailTables/IncomeDischarges/IncomeDetailTable";
import StayDetailTable from "components/Liquidations/LiquidationDetail/DetailTables/Stay/StayDetailTable";
import { LiquidationAggregation } from "types";
import LiquidationDetailsCard from "components/Liquidations/LiquidationDetail/LiquidationDetailsCard";
import TotalCards from "components/Liquidations/LiquidationDetail/TotalCards";
import { PrintLayout } from "components/Prints/PrintLayout";
import { chipHandler } from "components/utils/LiquidationDetails";
import { formatLiquidationNo } from "helpers/liquidations";

type LiquidationPrintLayoutProps = {
  consolidatedLiquidation: LiquidationAggregation;
  liquidationsToPrint: LiquidationAggregation[];
  hasDetail: boolean;
};

export const LiquidationPrintLayout = ({
  consolidatedLiquidation,
  liquidationsToPrint,
  hasDetail,
}: LiquidationPrintLayoutProps) => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <TotalCards print liquidation={consolidatedLiquidation} />
      </Grid>

      {liquidationsToPrint.map((currentLiquidation, index) => {
        const currentClient = currentLiquidation.liquidation_clients?.[0];

        return (
          <Grid item xs={12} key={currentLiquidation.id}>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <Typography variant="h6">
                  {currentLiquidation.parent_liquidation_id
                    ? `Liquidación Línea - ${currentClient?.razon_social ?? "-"}`
                    : `Liquidación - ${currentClient?.razon_social ?? "-"}`}
                </Typography>
              </Grid>

              <Grid item xs={12}>
                <LiquidationDetailsCard
                  liquidation={currentLiquidation}
                  incomeChip={chipHandler(
                    currentLiquidation.liquidation_settlement_types[0]
                      .settlement_type
                  )}
                  stayChip={chipHandler(
                    currentLiquidation.liquidation_settlement_types[1]
                      .settlement_type
                  )}
                  dischargeChip={chipHandler(
                    currentLiquidation.liquidation_settlement_types[2]
                      .settlement_type
                  )}
                  id={formatLiquidationNo(currentLiquidation, index)}
                />
              </Grid>

              <Grid item xs={12}>
                {currentLiquidation.liquidation_settlement_types[0].subtotal > 0 && (
                  <IncomeDetailTable
                    print
                    liquidation={currentLiquidation}
                    hasDetail={hasDetail}
                  />
                )}

                {currentLiquidation.liquidation_settlement_types[1].subtotal > 0 && (
                  <StayDetailTable
                    print
                    liquidation={currentLiquidation}
                    hasDetail={hasDetail}
                  />
                )}

                {currentLiquidation.liquidation_settlement_types[2].subtotal > 0 && (
                  <DischargeDetailTable
                    print
                    liquidation={currentLiquidation}
                    hasDetail={hasDetail}
                  />
                )}

                {currentLiquidation.subtotal_adicionales > 0 && (
                  <AdditionalDetailTable
                    print
                    liquidation={currentLiquidation}
                    hasDetail={hasDetail}
                  />
                )}
              </Grid>
            </Grid>
          </Grid>
        );
      })}
    </Grid>
  );
};